import qs from 'qs';
import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';

export const useQueryParams = () => {
  const { search, pathname } = useLocation();
  const navigate = useNavigate();

  const query = useMemo(() => new URLSearchParams(search), [search]);

  const setQuery = useCallback(
    (paramName: string, paramValue?: string) => {
      const queryParams = qs.parse(search, { ignoreQueryPrefix: true });
      const newQueries = { ...queryParams, [paramName]: paramValue };

      navigate(
        {
          pathname,
          search: qs.stringify(newQueries),
        },
        { replace: true },
      );
    },
    [search, navigate, pathname],
  );

  return { query, setQuery };
};
